import React, { useEffect } from 'react'
import DatePicker, { ReactDatePickerProps } from 'react-datepicker'
import { Control, Controller, FieldPath, FieldValues, RegisterOptions } from 'react-hook-form'

import { FormGroup } from './styles'

type DatepickerProps = Omit<ReactDatePickerProps<unknown>, 'onChange' | 'onBlur' | 'value'>

interface Props<TFieldValues extends FieldValues, TName extends FieldPath<TFieldValues>> extends DatepickerProps {
    name: TName
    control: Control<TFieldValues>
    rules?: Omit<RegisterOptions<TFieldValues, TName>, 'valueAsNumber' | 'valueAsDate' | 'setValueAs' | 'disabled'>
    label?: string
    setTime?: (k: Date | null) => void
}

// eslint-disable-next-line prettier/prettier, max-len
export function Datepicker<TFieldValues extends FieldValues, TName extends FieldPath<TFieldValues>>({
    name,
    control,
    rules,
    label,
    setTime,
    ...rest
}: Props<TFieldValues, TName>): JSX.Element {
    return (
        <Controller
            name={name}
            control={control}
            rules={rules}
            render={({ field, fieldState }) => (
                <FormGroup className={`form-group ${fieldState.error ? 'error' : 'has-success'}`}>
                    {label && <label className="control-label">{label}</label>}
                    <DatePicker
                        ref={field.ref}
                        onChange={field.onChange}
                        onBlur={field.onBlur}
                        value={field.value._d}
                        inline
                        {...rest}
                    />
                </FormGroup>
            )}
        />
    )
}
